import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, rem, colors } from '../../../styles';
var defaultStyles = function defaultStyles(_ref) {
  var type = _ref.type;
  return /*#__PURE__*/css("align-self:flex-start;border:", rem(1), " solid ", colors.navy_500, ";border-radius:", rem(4), ";display:block;flex-shrink:0;height:", rem(24), ";top:0;bottom:0;left:", rem(14), ";margin:auto 0;position:absolute;text-align:center;width:", rem(24), ";", type === 'radio' && /*#__PURE__*/css("border-radius:50%;width:", rem(24), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), ";svg{display:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('span');
var StyledSelectablePanelControlIcon = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e1ofpnfj0"
} : {
  target: "e1ofpnfj0",
  label: "StyledSelectablePanelControlIcon"
})(resetStyles, defaultStyles);
export default StyledSelectablePanelControlIcon;